"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'carpacAreaRefSrInfo',
      apiModule: 'kpiSet',
      searchQuery: {
        provinceList: [],
        cityList: [],
        empNo: '',
        empName: ''
      }
    };
  },
  computed: {
    domData: function domData() {
      return {
        // pcd: {
        //   label: this.$t('sfe.salesPerformance.pc'),
        //   inputType: 'pcd',
        //   level: 2,
        //   regionProps: { multiple: true, checkStrictly: false, value: 'label' },
        //   keyList: ['province', 'city'],
        //   returnArray: true
        // },
        pcd: {
          label: this.$t('common.provinceCity'),
          inputType: 'pcd_array',
          level: 2,
          regionProps: {
            multiple: true,
            checkStrictly: false,
            value: 'label'
          },
          keyList: ['provinceList', 'cityList'],
          returnArray: true
        },
        // province: {
        //   label: this.$t('common.province'),
        //   valueKey: 'province',
        //   contactQueryKey: 'cityCode',
        //   inputType: 'province',
        //   value: 'label',
        //   needLabelKey: true
        // },
        // city: {
        //   label: this.$t('common.city'),
        //   valueKey: 'city',
        //   contactQueryKey: 'districtCode',
        //   inputType: 'city',
        //   value: 'label',
        //   needLabelKey: true
        // },
        empNo: {
          label: this.$t('sfe.carpacAreaRefSrInfo.empNo'),
          valueKey: 'empNo'
        },
        empName: {
          label: this.$t('sfe.carpacAreaRefSrInfo.empName'),
          valueKey: 'empName'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.carpacarearefsrinfo'),
          apiUrl: '/protected/carpacAreaRefSrInfo/export'
        },
        import: {
          apiUrl: '/protected/carpacAreaRefSrInfo/import'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        province: {
          label: this.$t('common.province')
        },
        city: {
          label: this.$t('common.city')
        },
        empNo: {
          label: this.$t('sfe.carpacAreaRefSrInfo.empNo')
        },
        empName: {
          label: this.$t('sfe.carpacAreaRefSrInfo.empName')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/carpacAreaRefSrInfo/list'
      };
    }
  }
};